import { Link } from "react-router-dom";
import { DownloadSimple, Crown } from "@phosphor-icons/react";

const typeLabel = { icon_pack: "Icon Pack", widget: "Widget", wallpaper: "Wallpaper" };
const typeColor = { icon_pack: "#00E5FF", widget: "#FF00AA", wallpaper: "#FFEB3B" };

export default function ItemCard({ item, className = "" }) {
  const color = typeColor[item.type] || "#00E5FF";
  return (
    <Link
      to={`/item/${item.id}`}
      data-testid={`item-card-${item.id}`}
      className={`group relative flex flex-col overflow-hidden rounded-lg glass hover:border-white/30 transition-all duration-300 hover:-translate-y-1 ${className}`}
      style={{ boxShadow: "0 0 0 rgba(0,0,0,0)" }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = `0 0 28px ${color}44`)}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "0 0 0 rgba(0,0,0,0)")}
    >
      <div className="relative overflow-hidden aspect-[4/5]">
        <img
          src={item.preview_image}
          alt={item.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#05050A] via-transparent to-transparent" />
        <span
          className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.15em] px-2.5 py-1 rounded-sm"
          style={{ background: color, color: "#05050A" }}
        >
          {typeLabel[item.type]}
        </span>
        <span className="absolute top-3 right-3 flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#FFEB3B] bg-[#05050A]/70 px-2 py-1 rounded-sm">
          <Crown weight="fill" size={12} /> Premium
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-display font-bold text-base leading-tight mb-1 group-hover:text-[#00E5FF] transition-colors">
          {item.title}
        </h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-white/40 text-xs">{item.category}</span>
          <span className="flex items-center gap-1 text-white/40 text-xs">
            <DownloadSimple size={14} /> {item.download_count}
          </span>
        </div>
      </div>
    </Link>
  );
}
